import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@bt/shared';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AutoCoinPurchaseComponent } from './auto-coin-purchase.component';
import { ConfirmationModalContent } from "@bt/confirmation-modal/confirmation.modal";
import { CoinPurchaseInfoService } from "@bt/auto-coin-purchase/services/coinPurchaseInfo.service";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FontAwesomeModule,
    NgbTooltipModule
  ],
  entryComponents: [ConfirmationModalContent],
  providers:[CoinPurchaseInfoService],
  declarations: [
    AutoCoinPurchaseComponent,
  ],
})

export class AutoCoinPurchaseModule {
}



// WEBPACK FOOTER //
// ./src/app/auto-coin-purchase/auto-coin-purchase.module.ts